import { take, fork, cancel } from 'redux-saga/effects';
import * as firebase from './lib';

/**
 * The data in Redux should always mirror the data in Firebase, therefore when
 * a new copy of the Firebase Account is recieved over the Web Socket, we need
 * to dispatch the proper actions to parse it into Redux.
 *
 * Each of the following functions help facilitate this syncronization.
 *
 * @param path
 * @param callback
 * @param cancellationEvent
 * @param args
 */

export function* syncFirebasePath(path, callback, cancellationEvent, args) {
  const firebaseTask = yield fork(firebase.sync, path, callback, args);
  yield take(cancellationEvent);
  yield cancel(firebaseTask);
}

/**
 * When the section of Firebase being synced with Redux is a "table" of
 * keyed values (children), it is helpful to sync on the child-level
 * rather than replacing all children when one updates.
 *
 * @param path
 * @param pathCallback
 * @param childCallback
 * @param cancellationEvent
 * @param  args
 */

export function* syncFirebaseChildren(
  path,
  pathCallback,
  childCallback,
  cancellationEvent,
  args
) {
  const firebaseTask = yield fork(
    firebase.syncChildren,
    path,
    pathCallback,
    childCallback,
    args
  );
  yield take(cancellationEvent);
  yield cancel(firebaseTask);
}
